import React from 'react';
import { Row } from '../../lib/utils';
import SvgIcon from '../../components/SvgIcon';
import { MediumText } from '../../lib/Text';
import { colors } from '../../lib/colors';

type Props = {
    value?: number | null;
    fontSize?: number;
    isPercentage?: boolean;
};

function RateChangeText({ value, fontSize = 16, isPercentage = true }: Props) {
    const hasChange = value != null && value !== 0;
    const isMinus = (value ?? 0) < 0;
    const _value = Math.abs(value ?? 0);
    const textColor = hasChange ? (isMinus ? '#FF553E' : '#00A793') : colors.Text_1;

    return (
        <Row className="flex items-center ">
            {hasChange && (
                <SvgIcon
                    name="SvgEquilateralTriangle"
                    size={12}
                    fill={textColor}
                    className={`mr-[6px]
                    ${isMinus ? 'rotate-180' : ''}`}
                />
            )}
            <MediumText fontSize={fontSize} lineHeight={fontSize + 5} color={textColor} className="">
                {hasChange ? _value : '-'}
                {hasChange && isPercentage ? '%' : ''}
            </MediumText>
        </Row>
    );
}

export default RateChangeText;
